import { DetailsSvsState, SvsItem, SvsItemsTab } from './types';
import { SvsViews } from './model';
import { SvsDTO as SvsResponse, SvsDTOLine as SvsLine } from '../../../business/models/dto/svs/svs.dto';
import { BusinessResult } from '../../../business/models/policy-business.model';

export function mapSvsResponseToSvs(state: DetailsSvsState, response: SvsResponse): DetailsSvsState {
    const { tabValueAndCauseIsSaved, tabLinesIsSaved, tabVatAndPaymentIsSaved, tabCounterExpertiseIsSaved,
        tabSigningIsSaved, tabRemarkIsSaved, tabCommunicationIsSaved,

        cloned,
        cloneSuffererName,
        cloneSuffererLocation,
        cloneInsuredAmountBuilding,
        cloneInsuredAmountContent,
        documentAmazonKey,
        daccaRikAmazonKey,
        createdOn,
        createdByName,
        createdByFirstName,
        createdByLastName,
        createdByCompany,
        createdByCompanyDibCode,
        approved,
        ...responseWithoutTabSavedData } = response;

    const updatedTabs = [...state.tabs];
    updatedTabs[SvsViews.valueAndCause] = { ...updatedTabs[SvsViews.valueAndCause], isSaved: tabValueAndCauseIsSaved };
    updatedTabs[SvsViews.svsLines] = { ...updatedTabs[SvsViews.svsLines], isSaved: tabLinesIsSaved };
    updatedTabs[SvsViews.vatAndPayment] = { ...updatedTabs[SvsViews.vatAndPayment], isSaved: tabVatAndPaymentIsSaved };
    updatedTabs[SvsViews.counterExpertise] = { ...updatedTabs[SvsViews.counterExpertise], isSaved: tabCounterExpertiseIsSaved };
    updatedTabs[SvsViews.signing] = { ...updatedTabs[SvsViews.signing], isSaved: tabSigningIsSaved };
    updatedTabs[SvsViews.remark] = { ...updatedTabs[SvsViews.remark], isSaved: tabRemarkIsSaved };
    updatedTabs[SvsViews.communication] = { ...updatedTabs[SvsViews.communication], isSaved: tabCommunicationIsSaved };

    return {
        ...state, ...responseWithoutTabSavedData,
    };
}

export function mapSvsListResponseToSvs(state: DetailsSvsState, response: SvsResponse[]): DetailsSvsState {
    const newSvsItemsTab: SvsItemsTab = {};

    const newSvsItems = response.map(item => {
        const mappedItem: SvsItem = {
            id: item.id,
            total: item.lineAmountTotal,
            locked: item.locked,
            svsData: item
        };

        newSvsItemsTab[`${item.id}`] = {};
        newSvsItemsTab[`${item.id}`][SvsViews.svsLines] = { isSaved: item.tabLinesIsSaved, isDirty: false };
        newSvsItemsTab[`${item.id}`][SvsViews.valueAndCause] = { isSaved: item.tabValueAndCauseIsSaved, isDirty: false };
        newSvsItemsTab[`${item.id}`][SvsViews.vatAndPayment] = { isSaved: item.tabVatAndPaymentIsSaved, isDirty: false };
        newSvsItemsTab[`${item.id}`][SvsViews.counterExpertise] = { isSaved: item.tabCounterExpertiseIsSaved, isDirty: false };
        newSvsItemsTab[`${item.id}`][SvsViews.remark] = { isSaved: item.tabRemarkIsSaved, isDirty: false };
        newSvsItemsTab[`${item.id}`][SvsViews.communication] = { isSaved: item.tabCommunicationIsSaved, isDirty: false };
        newSvsItemsTab[`${item.id}`][SvsViews.signing] = { isSaved: item.tabSigningIsSaved, isDirty: false };

        return mappedItem;
    });

    return {
        ...state, svsItems: newSvsItems, svsItemsTabs: newSvsItemsTab
    };
}

export function mapPolicyBusinessToSvs(state: DetailsSvsState, businessResult: BusinessResult): DetailsSvsState {
    const policy = businessResult.data;

    let stateValidationErrors = state.validations;

    const validErrors = businessResult.validations;
    validErrors.filter(el => el.hasError === false).forEach(elem => {
        stateValidationErrors = stateValidationErrors.filter(item => item.businessValidationType !== elem.businessValidationType);
    });

    stateValidationErrors.push(...businessResult.validations);

    if (policy) {
    return {
        ...state,
        damageCauseRemarkIsValid: policy.Svs.damageCauseRemarkIsValid,
        damageRowExcessApplicableIsValid: policy.Svs.excessApplicableIsValid,
        damageRowUnderConditionIsValid: policy.Svs.underConditionIsValid,
        currentLine: { ...state.currentLine, description: policy.Svs.currentLine.description, amount: policy.Svs.currentLine.amount },
        lineAmountTotal: policy.Svs.svsTotal,
        lines: policy.Svs.svsLines.map(line => {
            const mappedLine: SvsLine = {
                id: line.id,
                amount: line.amount,
                description: line.description,
                lineFormatCode: '',
                sequence: line.sequence,
                svsHeaderID: line.svsHeaderID,
                deleted: line.deleted,
                isImportFromDacca: line.isImportFromDacca
            };

            return mappedLine;
        }),
        validations: stateValidationErrors,
        };
    } else {
        return {
            ...state,
            validations: stateValidationErrors
        };
    }
}
